import { createContext, ReactNode, useEffect, useMemo } from 'react';
import { useUserUUID } from 'utils/auth';
import { FeatureFlag } from '../constants';
import { useFeatureFlagsMutation } from '../query';
import { FeatureFlagsRequestData, UnleashContextState } from '../types';
import { getFeaturesDataFromList } from '../utils';

export const UnleashContext = createContext<UnleashContextState | undefined>(
  undefined
);

export const UnleashContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const { isLoading, mutate, data } = useFeatureFlagsMutation();
  const userId = useUserUUID();

  const mutateData: FeatureFlagsRequestData = useMemo(
    () => ({
      features: Object.values(FeatureFlag),
      context: {
        userId
      }
    }),
    [userId]
  );

  useEffect(() => {
    mutate(mutateData);
  }, [mutate, mutateData]);

  const contextValue = useMemo(
    () => ({ features: getFeaturesDataFromList(data?.features), isLoading }),
    [data?.features, isLoading]
  );

  return (
    <UnleashContext.Provider value={contextValue}>
      {children}
    </UnleashContext.Provider>
  );
};
